import React, { useRef, useState, useEffect } from "react";
import json from "../data.json";

const Hero = () => {
  // const [dimensions, setDimensions] = useState({ 
  //   height: document.querySelector('#root').offsetHeight,
  //   width: document.querySelector('#root').offsetWidth
  // })
  // const [width, setWidth] = useState(0)
  //
  // const scaleCoords = ({ coords = [], imgWidth, naturalWidth }) => {
  //   return coords.map(coord => coord * (imgWidth / naturalWidth))
  // }
  //
  // const drawPoly = (
  //   coords,
  //   fillColor,
  //   lineWidth,
  //   strokeColor,
  //   ctx,
  //   canvas
  // ) => {
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);
  //   ctx.globalCompositeOperation = 'source-over'
  //   ctx.fillStyle = fillColor
  //   ctx.fillRect(0, 0, canvas.width, canvas.height);
  //   ctx.globalCompositeOperation = "destination-out";
  //   const newCoords = coords.reduce((a, v, i, s) => (i % 2 ? a : [...a, s.slice(i, i + 2)]), []);
  //   ctx.beginPath();
  //   ctx.lineWidth = lineWidth;
  //   ctx.strokeStyle = strokeColor;
  //   newCoords.forEach(c =>ctx.lineTo(c[0], c[1]));
  //   ctx.closePath();
  //   ctx.fill();
  // };
  //
  // const tintWindow = (props) => {
  //   const {scaledCoords} = props 
  //   const canvas = document.getElementsByClassName('img-mapper-canvas')[0]
  //   canvas.height = document.getElementsByClassName('img-mapper-img')[0].offsetHeight
  //
  //   drawPoly(scaledCoords,'#ffffff99',  1, 'black', canvas.getContext('2d'), canvas)
  //
  //   canvas.classList.add("opacity--in")
  // }

  return (
    <>
      <div className="layout-item-wide hero">
        <h1 className="h1 hero__pretitle">Welcome to</h1>
        <h2 className="h2 hero__title">Motherwell</h2>
        <p className="para hero__body">Our factory in Scotland is the home of our haulers and we're inviting you in for a closer look. Your immersive factory experience begins here…</p>
        <button 
          className="hero__button"
          onClick={()=>{
          document.querySelectorAll(".icon").forEach((icon)=> {
          icon.style.zIndex = 9
          icon.style.opacity = 0.7
          })
          document.querySelectorAll(".icon")[0].focus()
          document.querySelectorAll(".icon")[0].style.zIndex = 10
          document.querySelectorAll(".icon")[0].style.opacity = 1
          document.querySelector(".mapper").scrollIntoView();
          // Disabled this as it's just cleaner when the map is not tinted
          // tintWindow({scaledCoords: scaleCoords({ coords: json[0].coords, imgWidth: dimensions.width, naturalWidth: width })})
          }}
        >
          Let's go
        </button>
      </div>
    </>
  );
}

export default Hero
